module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<h3>Brand</h3> <form id=\"brand-form\"> <div class=\"row\"> <div class=\"col-sm-6 col-lg-4\"> <div class=\"panel\"> <label> Name <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Used in page's <title> tag.\" data-placement=\"top\"></small> </label> <input id=\"name\" type=\"text\" class=\"form-control form-control-lg\" value=\"")
    ; __append(escapeFn( locals.brandName ))
    ; __append("\" placeholder=\"Example Company\"> </div> </div> <div class=\"col-sm-6 col-lg-4\"> <div id=\"color_picker\"></div> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 col-lg-4\"> <div class=\"panel\"> <div class=\"label-group\"> <label> Logo URL <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Link used when the Logo Image is clicked.\" data-placement=\"top\"></small> </label> <input id=\"logo_href\" type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.logoHref ))
    ; __append("\" placeholder=\"https://example.com\"> </div> <div class=\"label-group\"> <label>Logo Image</label> <div id=\"logo_image_upload\"></div> </div> </div> <button id=\"preview-tracking-page\" type=\"button\" class=\"btn btn-default btn-block\">Preview Tracking Page <small class=\"text-muted\">(Recommended)</small></button> <button type=\"submit\" class=\"btn btn-blue btn-block\">Save Brand</button> </div> <div class=\"col-sm-6 col-lg-4\"> <div class=\"panel\"> <div class=\"label-group\"> <label> Ad URL <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"Link used when the Ad Image is clicked.\" data-placement=\"top\"></small> </label> <input id=\"ad_href\" type=\"text\" class=\"form-control\" value=\"")
    ; __append(escapeFn( locals.adHref ))
    ; __append("\" placeholder=\"https://example.com/ad1\"> </div> <div class=\"label-group\"> <label>Ad Image <small class=\"text-muted\">min. width: ")
    ; __append(escapeFn( locals.adImgMinWidth ))
    ; __append("px</small> <small class=\"glyphicon glyphicon-question-sign text-muted hidden-xs\" data-toggle=\"tooltip\" title=\"")
    ; __append(escapeFn( locals.adImgMinWidth * 2 ))
    ; __append("px width recommended for viewing on high pixel-density devices (ex: Retina)\" data-placement=\"top\"></small></label> <div id=\"ad_image_upload\"></div> </div> </div> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 col-lg-4\"> </div> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/brand_page.ejs
// module id = 869
// module chunks = 1